import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const authState = atom({
    key: 'authState', // 고유한 key 값 설정
    default: {
        isLoggedIn: false,
        user: null, // 로그인 시 API가 전달한 user (club_id, club_admin_level, is_erp_booking_opened 등)
        token: null,
    },
	effects_UNSTABLE: [persistAtom],
});
